import { Injectable } from '@angular/core';
import { CheckoutRowStockService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class JeevesCheckoutRowStockService extends CheckoutRowStockService {
  // Mirrors the stock stamping in AssignOrderRowsJeevesComponent.handleCart (components/checkout/steps/assign-order-rows-jeeves/assign-order-rows-jeeves.component.ts);
  // keep the two in sync.
  public assignStock<T extends { targetStockId?: string; extra?: any }>(rows: T[]): T[] {
    // Ensure lagstalle is set on orderrows
    return rows.map(row => {
      return {
        ...row,
        extra: {
          ...row.extra,
          orp: {
            ...row.extra.orp,
            lagstalle: row.extra.orp && row.extra.orp.lagstalle ? row.extra.orp.lagstalle : row.targetStockId
          }
        }
      };
    });
  }
}
